import { render, staticRenderFns } from "./dualLink.vue?vue&type=template&id=514e3d84&"
import script from "./dualLink.vue?vue&type=script&lang=js&"
export * from "./dualLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports